export default __webpack_public_path__ + "static/media/extraction.27029011.png";